<template>
    <div>
        <b-row class="ml-1">
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>N°/Ano do Contrato Centralizado</b></span>
                <br />
                <span class="pos-left">{{ ctrCentralizado.NrContratoOrgaoResp+"/"+ctrCentralizado.NrAnoContratoOrgaoResp }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Órgão Responsável</b></span>
                <br />
                <span class="pos-left">{{ ctrCentralizado.NmOrgaoResp }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>CNPJ Órgão Responsável</b></span>
                <br />
                <span class="pos-left">{{ ctrCentralizado.NrCnpjOrgaoResp }}</span>
            </b-col>
        </b-row>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'

import { ContratoCentralizado } from '@/types/licitacoes/contratos/contrato-centralizado'

const CompProps = Vue.extend({
    name: 'DetalhesContratoLicitacaoOutraUG',
    props: {
        ctrCentralizado: {
            type: ContratoCentralizado,
            required: true
        }
    }
})

@Component
export default class DetalhesContratoCentralizado extends mixins(UtilsTS, CompProps) {}
</script>

<style></style>